import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { NotificationService, NotificationCount } from '../../services/notification.service';
import { ChatService, ChatConversationResponse } from '../../services/chat.service';
import { AvatarService } from '../../services/avatar.service';
import { ChatPopupComponent } from '../chat-popup/chat-popup.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterModule, ChatPopupComponent],
  template: `
    <nav class="navbar" [class.scrolled]="isScrolled">
      <div class="navbar-container">
        <!-- Logo and Brand -->
        <div class="navbar-brand">
          <a [routerLink]="authService.isAdmin() ? '/dashboard' : '/home'" class="brand-link">
            <div class="brand-logo">
              <img src="/assets/images/logo.png" alt="Familitive Logo" class="logo-image">
            </div>
            <span class="brand-text">Familitive</span>
          </a>
        </div>

        <!-- Desktop Navigation -->
        <div class="navbar-nav desktop-nav" [class.relative-login]="!authService.isAdmin()">
          <ng-container *ngIf="authService.isAuthenticated(); else notAuthenticated">
            <!-- Navigation Links -->
            <div class="nav-item" *ngIf="authService.isAdmin()">
              <a class="nav-link" routerLink="/dashboard" routerLinkActive="active">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <rect x="14" y="14" width="7" height="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Dashboard
              </a>
            </div>

            <div class="nav-item" *ngIf="authService.isAdmin()">
              <a class="nav-link approve-link" routerLink="/approve-relatives" routerLinkActive="active">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Approve Relative
              </a>
            </div>

            <div class="nav-item" *ngIf="authService.isAdmin()">
              <a class="nav-link" routerLink="/manage-relatives" routerLinkActive="active">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17 21V19A4 4 0 0 0 13 15H5A4 4 0 0 0 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M23 21V19A4 4 0 0 0 19.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 3.13A4 4 0 0 1 16 10.87" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Manage Relatives
              </a>
            </div>

            <!-- WhatsApp Button -->
            <div class="nav-item whatsapp-item">
              <button class="whatsapp-btn" (click)="openWhatsApp()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" fill="currentColor"/>
                </svg>
                <span class="whatsapp-text">Need Help?</span>
              </button>
            </div>

            <!-- Notification Bell -->
            <div class="nav-item notification-item" *ngIf="authService.isAuthenticated()">
              <button class="notification-btn" (click)="toggleNotificationDropdown()" [class.has-notifications]="notificationCount.unreadMessages > 0">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C8.13 2 5 5.13 5 9C5 11.38 5.97 13.5 7.5 14.9L7.5 18C7.5 18.55 7.95 19 8.5 19H15.5C16.05 19 16.5 18.55 16.5 18L16.5 14.9C18.03 13.5 19 11.38 19 9C19 5.13 15.87 2 12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 19V20C9 21.1 9.9 22 11 22H13C14.1 22 15 21.1 15 20V19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="notification-badge" *ngIf="notificationCount.unreadMessages > 0">{{ notificationCount.unreadMessages }}</span>
              </button>
              
              <!-- Notification Dropdown -->
              <div class="notification-dropdown" [class.show]="showNotificationDropdown">
                <div class="notification-header">
                  <h3>Messages</h3>
                  <button class="mark-all-read-btn" (click)="markAllAsRead()" *ngIf="notificationCount.unreadMessages > 0">
                    Mark all as read
                  </button>
                </div>
                <div class="notification-content">
                  <div *ngIf="isLoadingConversations" class="loading-conversations">
                    <div class="loading-spinner"></div>
                    <p>Loading conversations...</p>
                  </div>
                  <div *ngIf="!isLoadingConversations && conversations.length === 0" class="no-notifications">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="2"/>
                    </svg>
                    <p>No messages yet</p>
                    <small>Start chatting with your relatives</small>
                  </div>
                  <div *ngIf="!isLoadingConversations && conversations.length > 0" class="conversations-list">
                    <div *ngFor="let conversation of conversations" 
                         class="conversation-item" 
                         (click)="openChatWithRelative(conversation)"
                         [class.has-unread]="conversation.unreadCount > 0">
                      <div class="conversation-avatar">
                        <img *ngIf="conversation.otherUserProfileImageUrl" 
                             [src]="conversation.otherUserProfileImageUrl" 
                             [alt]="conversation.otherUserName"
                             class="avatar-image"
                             (error)="onImageError($event)">
                        <div *ngIf="!conversation.otherUserProfileImageUrl" 
                             class="avatar-placeholder">
                          {{ getInitials(conversation.otherUserName) }}
                        </div>
                        <span *ngIf="conversation.unreadCount > 0" class="unread-badge">{{ conversation.unreadCount }}</span>
                      </div>
                      <div class="conversation-details">
                        <div class="conversation-header">
                          <h4 class="conversation-name">{{ conversation.otherUserName }}</h4>
                          <span class="conversation-time" *ngIf="conversation.lastMessageAt">
                            {{ formatTime(conversation.lastMessageAt) }}
                          </span>
                        </div>
                        <p class="conversation-preview" [class.unread]="conversation.unreadCount > 0">
                          {{ conversation.lastMessage || 'No messages yet' }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- User Menu -->
            <div class="nav-item user-menu">
              <div class="user-menu-toggle" (click)="toggleUserMenu()" [class.active]="showUserMenu">
                <div class="user-avatar-large">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <svg class="dropdown-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polyline points="6,9 12,15 18,9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              
              <div class="user-menu-dropdown" [class.show]="showUserMenu">
                <div class="user-welcome-info">
                  <span class="welcome-text-dropdown">
                    Welcome, {{ authService.getCurrentUser()?.firstName || 'User' }}!
                    <small *ngIf="authService.isAdmin()" style="color: #667eea; font-weight: bold;">(Admin)</small>
                  </span>
                </div>
                <div class="menu-divider"></div>
                <!-- <div class="user-info">
                  <div class="user-name">{{ authService.getCurrentUser()?.firstName }} {{ authService.getCurrentUser()?.lastName }}</div>
                  <div class="user-email">{{ authService.getCurrentUser()?.email }}</div>
                </div>
                <div class="menu-divider"></div> -->
                <a class="menu-item" routerLink="/profile">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Profile
                </a>
                <a class="menu-item" routerLink="/settings" *ngIf="authService.isAdmin()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M19.4 15A1.65 1.65 0 0 0 21 12A1.65 1.65 0 0 0 19.4 9A1.65 1.65 0 0 0 18 7.4A1.65 1.65 0 0 0 15 6A1.65 1.65 0 0 0 12 7.4A1.65 1.65 0 0 0 9 6A1.65 1.65 0 0 0 6 7.4A1.65 1.65 0 0 0 4.6 9A1.65 1.65 0 0 0 3 12A1.65 1.65 0 0 0 4.6 15A1.65 1.65 0 0 0 6 16.6A1.65 1.65 0 0 0 9 18A1.65 1.65 0 0 0 12 16.6A1.65 1.65 0 0 0 15 18A1.65 1.65 0 0 0 18 16.6A1.65 1.65 0 0 0 19.4 15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Settings
                </a>
                <div class="menu-divider"></div>
                <button class="menu-item logout-btn" (click)="logout()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Logout
                </button>
              </div>
            </div>
          </ng-container>
          
          <ng-template #notAuthenticated>
            <div class="nav-item">
              <a class="nav-link" routerLink="/login" routerLinkActive="active">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 3H19A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="10,17 15,12 10,7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="15" y1="12" x2="3" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Login
              </a>
            </div>
            <div class="nav-item">
              <a class="nav-link signup-link" routerLink="/signup" routerLinkActive="active">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 21V19A4 4 0 0 0 12 15H5A4 4 0 0 0 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <circle cx="8.5" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="20" y1="8" x2="20" y2="14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="23" y1="11" x2="17" y2="11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Sign Up
              </a>
            </div>
          </ng-template>
        </div>

        <!-- Mobile Menu Toggle -->
        <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" [class.active]="showMobileMenu">
          <span class="hamburger-line"></span>
          <span class="hamburger-line"></span>
          <span class="hamburger-line"></span>
        </button>
      </div>

      <!-- Mobile Navigation -->
      <div class="mobile-nav" [class.show]="showMobileMenu">
        <ng-container *ngIf="authService.isAuthenticated(); else mobileNotAuthenticated">
          <div class="mobile-user-info">
            <div class="mobile-user-avatar">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="mobile-user-details">
              <div class="mobile-user-name">{{ authService.getCurrentUser()?.firstName }} {{ authService.getCurrentUser()?.lastName }}</div>
              <div class="mobile-user-email">{{ authService.getCurrentUser()?.email }}</div>
            </div>
            <!-- Mobile WhatsApp Button -->
            <div class="mobile-whatsapp-item">
              <button class="mobile-whatsapp-btn" (click)="openWhatsApp()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" fill="currentColor"/>
                </svg>
                <span class="mobile-whatsapp-text">Need Help?</span>
              </button>
            </div>

            <!-- Mobile Notification Icon -->
            <div class="mobile-notification-item">
              <button class="mobile-notification-btn" (click)="toggleNotificationDropdown()" [class.has-notifications]="notificationCount.unreadMessages > 0">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C8.13 2 5 5.13 5 9C5 11.38 5.97 13.5 7.5 14.9L7.5 18C7.5 18.55 7.95 19 8.5 19H15.5C16.05 19 16.5 18.55 16.5 18L16.5 14.9C18.03 13.5 19 11.38 19 9C19 5.13 15.87 2 12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 19V20C9 21.1 9.9 22 11 22H13C14.1 22 15 21.1 15 20V19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="mobile-notification-badge" *ngIf="notificationCount.unreadMessages > 0">{{ notificationCount.unreadMessages }}</span>
              </button>
              
              <!-- Mobile Notification Dropdown -->
              <div class="mobile-notification-dropdown" [class.show]="showNotificationDropdown">
                <div class="mobile-notification-header">
                  <h3>Messages</h3>
                  <button class="mobile-mark-all-read-btn" (click)="markAllAsRead()" *ngIf="notificationCount.unreadMessages > 0">
                    Mark all as read
                  </button>
                </div>
                <div class="mobile-notification-content">
                  <div *ngIf="isLoadingConversations" class="mobile-loading-conversations">
                    <div class="mobile-loading-spinner"></div>
                    <p>Loading conversations...</p>
                  </div>
                  <div *ngIf="!isLoadingConversations && conversations.length === 0" class="mobile-no-notifications">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="2"/>
                    </svg>
                    <p>No messages yet</p>
                    <small>Start chatting with your relatives</small>
                  </div>
                  <div *ngIf="!isLoadingConversations && conversations.length > 0" class="mobile-conversations-list">
                    <div *ngFor="let conversation of conversations" 
                         class="mobile-conversation-item" 
                         (click)="openChatWithRelative(conversation)"
                         [class.has-unread]="conversation.unreadCount > 0">
                      <div class="mobile-conversation-avatar">
                        <img *ngIf="conversation.otherUserProfileImageUrl" 
                             [src]="conversation.otherUserProfileImageUrl" 
                             [alt]="conversation.otherUserName"
                             class="mobile-avatar-image"
                             (error)="onImageError($event)">
                        <div *ngIf="!conversation.otherUserProfileImageUrl" 
                             class="mobile-avatar-placeholder">
                          {{ getInitials(conversation.otherUserName) }}
                        </div>
                        <span *ngIf="conversation.unreadCount > 0" class="mobile-unread-badge">{{ conversation.unreadCount }}</span>
                      </div>
                      <div class="mobile-conversation-details">
                        <div class="mobile-conversation-header">
                          <h4 class="mobile-conversation-name">{{ conversation.otherUserName }}</h4>
                          <span class="mobile-conversation-time" *ngIf="conversation.lastMessageAt">
                            {{ formatTime(conversation.lastMessageAt) }}
                          </span>
                        </div>
                        <p class="mobile-conversation-preview" [class.unread]="conversation.unreadCount > 0">
                          {{ conversation.lastMessage || 'No messages yet' }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <a class="mobile-nav-link" *ngIf="authService.isAdmin()" routerLink="/dashboard" (click)="closeMobileMenu()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <rect x="14" y="14" width="7" height="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Dashboard
          </a>
          
          <a class="mobile-nav-link" *ngIf="authService.isAdmin()" routerLink="/approve-relatives" (click)="closeMobileMenu()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Approve Relative
          </a>
          
          <a class="mobile-nav-link" *ngIf="authService.isAdmin()" routerLink="/manage-relatives" (click)="closeMobileMenu()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 21V19A4 4 0 0 0 13 15H5A4 4 0 0 0 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M23 21V19A4 4 0 0 0 19.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16 3.13A4 4 0 0 1 16 10.87" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Manage Relatives
          </a>
          
          <a class="mobile-nav-link" routerLink="/profile" (click)="closeMobileMenu()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Profile
          </a>
          
          <a class="mobile-nav-link" routerLink="/settings" (click)="closeMobileMenu()" *ngIf="authService.isAdmin()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M19.4 15A1.65 1.65 0 0 0 21 12A1.65 1.65 0 0 0 19.4 9A1.65 1.65 0 0 0 18 7.4A1.65 1.65 0 0 0 15 6A1.65 1.65 0 0 0 12 7.4A1.65 1.65 0 0 0 9 6A1.65 1.65 0 0 0 6 7.4A1.65 1.65 0 0 0 4.6 9A1.65 1.65 0 0 0 3 12A1.65 1.65 0 0 0 4.6 15A1.65 1.65 0 0 0 6 16.6A1.65 1.65 0 0 0 9 18A1.65 1.65 0 0 0 12 16.6A1.65 1.65 0 0 0 15 18A1.65 1.65 0 0 0 18 16.6A1.65 1.65 0 0 0 19.4 15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Settings
          </a>
          
          <button class="mobile-logout-btn" (click)="logout(); closeMobileMenu()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Logout
          </button>
        </ng-container>
        
        <ng-template #mobileNotAuthenticated>
          <a class="mobile-nav-link" routerLink="/login" (click)="closeMobileMenu()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 3H19A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <polyline points="10,17 15,12 10,7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <line x1="15" y1="12" x2="3" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Login
          </a>
          
          <a class="mobile-nav-link" routerLink="/signup" (click)="closeMobileMenu()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 21V19A4 4 0 0 0 12 15H5A4 4 0 0 0 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="8.5" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <line x1="20" y1="8" x2="20" y2="14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <line x1="23" y1="11" x2="17" y2="11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Sign Up
          </a>
        </ng-template>
      </div>
    </nav>

    <!-- Chat Popup -->
    <app-chat-popup
      [isVisible]="showChatPopup"
      [otherUserId]="chatOtherUserId"
      [otherUserName]="chatOtherUserName"
      [otherUserProfileImageUrl]="chatOtherUserProfileImageUrl"
      (closeChat)="closeChatPopup()">
    </app-chat-popup>
  `,
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {
  isScrolled = false;
  showUserMenu = false;
  showMobileMenu = false;
  showNotificationDropdown = false;
  notificationCount: NotificationCount = { unreadMessages: 0, totalNotifications: 0 };
  conversations: ChatConversationResponse[] = [];
  isLoadingConversations = false;
  
  // Chat popup properties
  showChatPopup = false;
  chatOtherUserId = 0;
  chatOtherUserName = '';
  chatOtherUserProfileImageUrl?: string;
  
  // Cached default avatar as data URL to avoid repeated requests
  readonly defaultAvatarUrl = this.avatarService.getDefaultAvatarUrl();
  
  private notificationSubscription?: Subscription;

  constructor(
    public authService: AuthService,
    private router: Router,
    private notificationService: NotificationService,
    private chatService: ChatService,
    private avatarService: AvatarService
  ) {}

  ngOnInit(): void {
    console.log('🔍 NavbarComponent - ngOnInit called');
    console.log('🔍 NavbarComponent - isAuthenticated:', this.authService.isAuthenticated());
    console.log('🔍 NavbarComponent - isAdmin:', this.authService.isAdmin());
    console.log('🔍 NavbarComponent - currentUser:', this.authService.getCurrentUser());
    
    // Listen for scroll events to add scrolled class
    window.addEventListener('scroll', () => {
      this.isScrolled = window.scrollY > 10;
    });

    // Close menus when clicking outside
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.user-menu') && !target.closest('.mobile-menu-toggle') && !target.closest('.notification-item')) {
        this.showUserMenu = false;
        this.showMobileMenu = false;
        this.showNotificationDropdown = false;
      }
    });

    // Subscribe to notification count updates
    if (this.authService.isAuthenticated()) {
      this.loadNotificationCount();
      this.notificationSubscription = this.notificationService.getNotificationCount().subscribe(
        count => this.notificationCount = count
      );
    }
  }

  ngOnDestroy(): void {
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
  }

  toggleUserMenu(): void {
    this.showUserMenu = !this.showUserMenu;
    this.showMobileMenu = false; // Close mobile menu if open
    this.showNotificationDropdown = false; // Close notification dropdown if open
  }

  toggleMobileMenu(): void {
    this.showMobileMenu = !this.showMobileMenu;
    this.showUserMenu = false; // Close user menu if open
    this.showNotificationDropdown = false; // Close notification dropdown if open
  }

  toggleNotificationDropdown(): void {
    this.showNotificationDropdown = !this.showNotificationDropdown;
    this.showUserMenu = false; // Close user menu if open
    this.showMobileMenu = false; // Close mobile menu if open
    
    // Load conversations when opening dropdown
    if (this.showNotificationDropdown) {
      this.loadConversations();
    }
  }

  closeMobileMenu(): void {
    this.showMobileMenu = false;
  }

  loadNotificationCount(): void {
    this.notificationService.fetchNotificationCount().subscribe({
      next: (count) => {
        this.notificationCount = count;
      },
      error: (error) => {
        console.error('Failed to load notification count:', error);
      }
    });
  }

  markAllAsRead(): void {
    // This would typically call an API to mark all notifications as read
    // For now, we'll just clear the local count
    this.notificationService.clearNotifications();
    this.showNotificationDropdown = false;
  }

  logout(): void {
    console.log('🚪 Logout: User logging out');
    console.log('🚪 Logout: Before logout - isAuthenticated:', this.authService.isAuthenticated());
    this.authService.logout();
    console.log('🚪 Logout: After logout - isAuthenticated:', this.authService.isAuthenticated());
    this.showUserMenu = false;
    this.showMobileMenu = false;
    
    // Redirect to login page
    console.log('🚪 Logout: Navigating to login page');
    this.router.navigate(['/login']);
  }

  /**
   * Load conversations for the notification dropdown
   */
  loadConversations(): void {
    this.isLoadingConversations = true;
    this.chatService.getConversations().subscribe({
      next: (response: any) => {
        this.isLoadingConversations = false;
        if (response.success) {
          this.conversations = response.data || [];
          console.log('🔍 Loaded conversations:', this.conversations);
        } else {
          console.error('Failed to load conversations:', response.message);
          this.conversations = [];
        }
      },
      error: (error) => {
        this.isLoadingConversations = false;
        console.error('Error loading conversations:', error);
        this.conversations = [];
      }
    });
  }

  /**
   * Open chat with a relative from notification dropdown
   */
  openChatWithRelative(conversation: ChatConversationResponse): void {
    console.log('🔍 Opening chat with relative:', conversation);
    
    this.chatOtherUserId = conversation.otherUserId;
    this.chatOtherUserName = conversation.otherUserName || 'Unknown User';
    this.chatOtherUserProfileImageUrl = conversation.otherUserProfileImageUrl;
    this.showChatPopup = true;
    this.showNotificationDropdown = false; // Close notification dropdown
    
    console.log('🔍 Chat popup data:', {
      otherUserId: this.chatOtherUserId,
      otherUserName: this.chatOtherUserName,
      otherUserProfileImageUrl: this.chatOtherUserProfileImageUrl
    });
  }

  /**
   * Close chat popup
   */
  closeChatPopup(): void {
    this.showChatPopup = false;
    this.chatOtherUserId = 0;
    this.chatOtherUserName = '';
    this.chatOtherUserProfileImageUrl = undefined;
  }

  /**
   * Format time for conversation list
   */
  formatTime(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60);

    if (diffInHours < 1) {
      return 'Just now';
    } else if (diffInHours < 24) {
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } else if (diffInHours < 48) {
      return 'Yesterday';
    } else {
      return date.toLocaleDateString();
    }
  }

  /**
   * Handle image loading errors
   */
  onImageError(event: Event): void {
    this.avatarService.handleImageError(event);
  }

  /**
   * Get initials from name
   */
  getInitials(name: string): string {
    return this.avatarService.getInitials(name);
  }

  /**
   * Open WhatsApp with the specified number
   */
  openWhatsApp(): void {
    const phoneNumber = '9481664563';
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl, '_blank');
  }
}
